import React, { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import styles from './TableMerge.module.css';

const TagsInput = forwardRef((props, ref) => {
  const { selectedTags } = props;
  const [tags, setTags] = useState([]);
  const [input, setInput] = useState('');
  const inputRef = useRef(null);

  const removeTags = indexToRemove => {
    const newTags = [...tags.filter((_, index) => index !== indexToRemove)];
    setTags(newTags);
    selectedTags && selectedTags(newTags);
  };

  const handleAddTags = () => {
    if (input !== '') {
      setTags([...tags, input]);
      selectedTags && selectedTags([...tags, input]);
      setInput('');
    }
  };

  useImperativeHandle(ref, () => ({
    addTags: () => {
      handleAddTags();
      inputRef.current.focus();
    },
  }));

  return (
    <div className={styles.tagsInput}>
      <ul className={styles.tags}>
        {tags.map((tag, index) => (
          <li key={index} className={styles.tag}>
            <span className={styles.tagTitle}>{tag}</span>
            <span className={styles.tagCloseIcon}
              onClick={() => removeTags(index)}
            >
              X
						</span>
          </li>
        ))}
      </ul>
      <input
        ref={inputRef}
        value={input}
        className={styles.input}
        type="tel"
        onChange={event => setInput(event.target.value)}
        onKeyUp={event => event.key === "Enter" ? handleAddTags() : null}
        placeholder="Enter Table #"
      />
    </div>
  );
});

export default TagsInput;
